













































































import {API} from '@/services/api/api';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import FilterMenu from '@/components/FilterMenu.vue';
import InsapectionList from '@/components/InspectionListComponent.vue';
import ShipList from '@/models/shiplist';
import {Utils} from '@/utils/Utils';
import PDFTemplate from '@/components/template/PDFTemplate.vue';
@Component({
  components: {
    FilterMenu,
    InsapectionList,
    PDFTemplate,
  },
  // computed: {...mapGetters(['shipList'])},
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class ShipInspectionList extends Vue {
  showErrorToast: any;
  showSuccessToast: any;
  shipId: number = null;
  dateFrom = null;
  dateUpto = null;
  inspectionList = [];
  shipImageUrl = '';
  shipName = '';
  // shipList: ShipList;
  deckImageUrl = '';
  shipDetails = {};
  deckName = '';
  showDeleteBtn = false;
  showDeletEntireBtn = false;

  deleteBtnLoader = false;
  isScreenLoading = false;
  componentName = 'InspectionListPage';
  printBtnLoader = false;
  id: number = 0;
  findingsId: number = null;
  severityId: number = null;
  voyageId: number = null;
  inspectorId: number = null;

  showCreateBtn = Utils.manageRoutePermissions('inspection', 2);

  handleAPIBasedOnRoute() {
    if (this.$route.name === 'severity') {
      let params = {
        SeverityId: Number.parseInt(this.$route.params.id),
      };
      return this.getInspectionList(params);
      //
    } else if (this.$route.name === 'findings') {
      let params = {
        FindingId: Number.parseInt(this.$route.params.id),
      };
      return this.getInspectionList(params);
      //
    } else if (this.$route.name === 'inspector') {
      let params = {
        InspectorId: Number.parseInt(this.$route.params.id),
      };
      return this.getInspectionList(params);
      //
    } else if (this.$route.name === 'ship') {
      let params = {
        ShipId: Number.parseInt(this.$route.params.id),
      };
      return this.getInspectionList(params);
      //
    } else if (this.$route.name === 'voyage') {
      let params = {
        VoyageId: Number.parseInt(this.$route.params.id),
      };
      return this.getInspectionList(params);
    } else {
      return this.getInspectionList();
    }
  }

  async getInspectionList(params = null) {
    this.isScreenLoading = true;

    try {
      this.inspectionList = [];
      // const param = {
      //   SeverityId: this.severityId,
      //   FindingId: this.findingsId,
      //   InspectorId: this.inspectorId,
      //   VoyageId: this.voyageId,
      // };

      const response = await API.getInspectionList(params);

      if (response.data) {
        this.inspectionList = response.data;
        this.deleteBtnLoader = false;

        //
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.showErrorToast({msg: 'Network error'});
      }
      //
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }
  toggleDeleteBtns(checkBoxStatus) {
    this.showDeleteBtn = checkBoxStatus.delete;
    this.showDeletEntireBtn = checkBoxStatus.deleteEntire;
  }

  closeDeleteBtnLoader() {
    this.deleteBtnLoader = false;
  }

  onDeleteClick() {
    this.deleteBtnLoader = true;
    const inspectionComponentRef: any = this.$refs.inspectionComponentRef;
    inspectionComponentRef.onDeleteClick();
  }

  onDeleteEntireClick() {
    const inspectionComponentRef: any = this.$refs.inspectionComponentRef;
    inspectionComponentRef.onDeleteEntireClick();
  }

  goToCreatePage() {
    this.$router.push('/create-inspection');
  }

  stopBtnLoader() {
    this.printBtnLoader = false;
  }

  onPrintClick() {
    this.printBtnLoader = true;
    const ref: any = this.$refs.pdfTemplateRef;
    ref.htmlToPdf();
  }
  // watch: {
  //     $route(to, from) {
  //       // react to route changes...
  //     }
  @Watch('$route', {immediate: true})
  onrouteChange(newValue: any, oldValue: any) {
    if (newValue) {
      this.handleAPIBasedOnRoute();
    }
  }
}
